// Page univers /fr/guides/aeroports — indexable seulement si ≥ 3 guides publiés
import { Navigate } from "react-router-dom";
import { JsonLd, SeoPage, useHreflang, useSeo } from "@/components/seo/Seo";
import { GuideCard } from "@/components/guides/GuideBlocks";
import { BASE_URL, LANGS, p } from "@/lib/seoContent";
import { CLUSTERS, GUIDES_COPY, clusterIndexable, clusterUrl, guidesHubUrl, guidesInCluster } from "@/lib/guides";

export default function GuideCluster({ lang, clusterId }) {
  const cl = CLUSTERS[clusterId];
  const c = GUIDES_COPY[lang];
  const path = cl ? clusterUrl(lang, clusterId) : guidesHubUrl(lang);
  const guides = cl ? guidesInCluster(lang, clusterId) : [];
  const noindex = !cl || !clusterIndexable(lang, clusterId);
  useSeo({ lang, title: cl ? `${cl.name[lang]} — ${c.title}` : c.title, description: cl ? cl.intro[lang] : c.meta, path, type: "guide-cluster", id: clusterId, noindex });
  useHreflang(cl ? Object.fromEntries(LANGS.map((l) => [l, clusterUrl(l, clusterId)])) : null);
  if (!cl) return <Navigate to={guidesHubUrl(lang)} replace />;

  const crumbs = [{ label: c.home, to: p(lang) }, { label: c.title, to: guidesHubUrl(lang) }, { label: cl.name[lang] }];
  const jsonLd = [{ "@context": "https://schema.org", "@type": "BreadcrumbList",
    itemListElement: crumbs.map((x, i) => ({ "@type": "ListItem", position: i + 1, name: x.label, ...(x.to ? { item: `${BASE_URL}${x.to}` } : {}) })) }];

  return (
    <SeoPage lang={lang} breadcrumbs={crumbs} testId={`guide-cluster-${clusterId}`}>
      <JsonLd id="guide-cluster" data={jsonLd} />
      <header className="max-w-3xl">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-miles">{c.eyebrow}</p>
        <h1 className="mt-3 text-4xl font-bold tracking-tight text-ink sm:text-5xl">{cl.name[lang]}</h1>
        <p className="mt-5 text-base leading-relaxed text-slate sm:text-lg">{cl.intro[lang]}</p>
      </header>
      <section className="mt-12" data-testid="cluster-guides">
        {guides.length ? (
          <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">{guides.map((g) => <GuideCard key={g.id} g={g} lang={lang} />)}</div>
        ) : (
          <p className="rounded-2xl border border-dashed border-ink/15 px-6 py-10 text-center text-sm text-slate" data-testid="cluster-empty">{c.empty}</p>
        )}
      </section>
    </SeoPage>
  );
}
